import {ObjTools} from "./objTools";

/**
 * Browser tools.
 */
export class BrowserTools {

    /**
     * Get location.
     *
     * @param showPosition function to call when position is available
     * @param showError function to call for error
     */
    static getLocation(showPosition, showError) {
        if (ObjTools.isNully(showPosition)) {
            showPosition = pos => console.log('position: ' + pos);
        }

        if (ObjTools.isNully(showError)) {
            showError = function (error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        throw "User denied the request for Geolocation.";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        throw "Location information is unavailable.";
                        break;
                    case error.TIMEOUT:
                        throw "The request to get user location timed out.";
                        break;
                    case error.UNKNOWN_ERROR:
                        throw "An unknown error occurred.";
                        break;
                }
            }
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition, showError);
        } else {
            throw "Geolocation is not supported by this browser.";
        }
    }

    static getUserLocalIp() {
        var ip = false;
        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || false;

        if (window.RTCPeerConnection) {
            ip = [];
            var pc = new RTCPeerConnection({iceServers: []}), noop = function () {
            };
            pc.createDataChannel('');
            pc.createOffer(pc.setLocalDescription.bind(pc), noop);

            pc.onicecandidate = function (event) {
                if (event && event.candidate && event.candidate.candidate) {
                    var s = event.candidate.candidate.split('\n');
                    ip.push(s[0].split(' ')[4]);
                }
            }
        }

        return ip;
    }

    /**
     * Function to get a value from a list of elements where the first valid element value is retrieved.
     * @returns first valid element value
     */
    static getMultiElementVal() {
        let value = null;

        for (let i = 0; i < arguments.length; i++) {
            try {
                if (!ObjTools.isNully(arguments[i])) {
                    const obj = $("#" + arguments[i]);
                    if (!ObjTools.isNully(obj)) {
                        if (obj.is('input:checkbox')) {
                            value = obj.is(':checked') ? 1 : 0;
                        } else if (obj.is('textarea')) {
                            value = obj.html();
                        } else {
                            value = obj.val();
                        }
                    }
                }
            } catch (e) {
                console.error("Error while reading value.");
                console.error(e);
            }

            if (!ObjTools.isNullyOrEmpty(value)) {
                break;
            }
        }

        return value;
    }
}

/**
 * Permits delay of typing until timer runs out.
 * Then it executes a function.
 *
 * @returns {Function}
 */
BrowserTools.typewatch = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    }
})();